// La ruta del modo Redes — ADR-2026-10-01-modo-redes. Sin `:sesionId` es la portada; con
// él, el lienzo de la sesión. Entrar no pide plan —como Prompt libre—; generar video lo pide
// adentro, al tocar Generar.
//
// Ya no es sólo de escritorio (ADR-2026-10-09-asistente-en-crear): en el teléfono la portada
// tiene su versión simple (el interruptor acostado arriba de la caja, sin el abanico) y los
// resultados son la cuadrícula en dos columnas, sin el Canva.

import { useParams } from 'react-router-dom';
import { PantallaRedes } from './PantallaRedes';

const RedesMode: React.FC = () => {
  const { sesionId } = useParams<{ sesionId?: string }>();
  return <PantallaRedes sesionId={sesionId} />;
};

export default RedesMode;
